(function($) {

  // init main menu
  var $mainmenu_nl = $('#menu-main-menu');
  var $mainmenu_en = $('#menu-main-menu-en');
  if ( !$('body').hasClass('home') ) {
    $mainmenu_nl.addClass('collapsed');
    $mainmenu_en.addClass('collapsed');
  }

  // Main navigation Hamburger toggler
  $('.menu-toggler').click(function(){
    if ( $mainmenu_nl.hasClass('expanded') ) {
      $mainmenu_nl.removeClass('expanded');
      $mainmenu_nl.addClass('collapsed');
    } else {
      $mainmenu_nl.addClass('expanded');
      $mainmenu_nl.removeClass('collapsed');
    }
    if ( $mainmenu_en.hasClass('expanded') ) {
      $mainmenu_en.removeClass('expanded');
      $mainmenu_en.addClass('collapsed');
    } else {
      $mainmenu_en.addClass('expanded');
      $mainmenu_en.removeClass('collapsed');
    }
  });
})(jQuery);
